import {Bridge} from '@mk/bridge';

function goToAnchor(name) {
  const returnEle = document.querySelector(name);  // 将要跳转区域的锚点id
  if (returnEle) {
    returnEle.scrollIntoView(true);
  }
}


function redirectURL(itemVal, appType = 'seller') {
  var ua = window.navigator.userAgent;
  var query = location.href.indexOf('?') > -1 && location.href.split('?')[1] || null;
  var matchUrl = /^((ht|f)tps?):\/\/([\w-]+(\.[\w-]+)*\/?)+(\?([\w\-\.,@?^=%&:\/~\+#]*)+)?$/;
  if (itemVal.startsWith('#')) {
    goToAnchor(itemVal);
    return;
  }
  if (itemVal) {
    // 链接直接跳转
    if (matchUrl.test(itemVal)) {
      location.href = itemVal;
      return;
    }
    if (ua.match(/Mockuai(Buyer)?\/([\d\.]+)/)) {
      setEventTrackInfo();
      if (appType == 'buyer') {
        location.href = 'mockuaibuyer://buyer/item?item_id=' + itemVal;
      } else {
        if (itemVal && itemVal.match(/mockuaiseller:/)) {
          location.href = itemVal;
        } else {
          location.href = 'mockuaiseller://seller/item?item_id=' + itemVal;
        }
      }
    } else if (ua.match(/Wdzg\/([\d\.]+)/)) { // 无敌掌柜B端
      setEventTrackInfo();
      if (itemVal && itemVal.match(/mockuaiweishi:/)) {
        location.href = itemVal;
      } else {
        location.href = 'mockuaiweishi://seller/item?item_id=' + itemVal;
      }
    } else if (ua.match(/Wdzb\/([\d\.]+)/)) { // 无敌主播
      setEventTrackInfo();
      if (itemVal && itemVal.match(/wudizhubo:/)) {
        location.href = itemVal;
      } else {
        location.href = 'wudizhubo://seller/item?item_id=' + itemVal;
      }
    } else if (ua.match(/Kwai\/([\d\.]+)/)) {
      location.href = 'https://wap.mockuai.com/detail?item_id=' + itemVal;
    } else if (ua.indexOf('MicroMessenger') > -1) {
      // 达人加参数fromType=promotion&   c端小程序不加参数
      var mini_url = '';
      if (itemVal && (itemVal.indexOf('pages/') > -1 || itemVal.indexOf('page/') > -1)) {
        if (query) {
          if (itemVal.indexOf('?') > -1) {
            mini_url = itemVal + '&' + query;
          } else {
            mini_url = itemVal + '?' + query;
          }
        } else {
          mini_url = itemVal;
        }
      } else {
        if (query) {
          mini_url = '/pages/main/item/detail?item_id=' + itemVal + '&' + query;
        } else {
          mini_url = '/pages/main/item/detail?item_id=' + itemVal;
        }
      }
      wx.miniProgram.navigateTo({
        url: mini_url
      });
    } else if (/(^[a-zA-Z]+):\/\/[-A-Za-z0-9+&@#/%?=~_|!:,.;]+[-A-Za-z0-9+&@#/%=~_|]/.test(itemVal)) {
      // h5 拉起其他App 如微信小程序
      location.href = itemVal;
    } else {
      location.href = 'https://wapws.mockuai.com/detail?item_id=' + itemVal;
    }
  }
}

function setEventTrackInfo() {
  try {
    const bridge = new Bridge();
    bridge.ready((apis, bridge, env) => {
      bridge.register('setEventTrackInfo', {last_click_tag:(window.eventData || {}).trace_tag}, () => {});
    });
  } catch (err) {
  }
}

module.exports = {
  redirectURL
};
